module.exports = __webpack_public_path__ + "static/img/mi.97a2789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mi.png
// module id = G/AX
// module chunks = 2